export default "/static/baton/app/dist/28b74339da09e9f659af06a6401a4ddd.ttf";